import moment, { Moment } from 'moment'

export default function formatRelativeTime(time: Moment, from: Moment = moment()) {
  const calendarDays = from.clone().startOf('day').diff(time.clone().startOf('day'), 'days')
  const dateLabel = time.format('ddd, MMM D')

  if (calendarDays === 0) {
    return `${dateLabel} · Today`
  }
  if (calendarDays === 1) {
    return `${dateLabel} · Yesterday`
  }
  if (calendarDays >= 2 && calendarDays <= 6) {
    return `${dateLabel} · ${calendarDays} days ago`
  }
  if (calendarDays === -1) {
    return 'Tomorrow'
  }

  const defaultFormat = time.year() === from.year() ? 'ddd, MMM Do' : 'MMM Do, YYYY'
  return time.format(defaultFormat)
}
